import React from 'react'

// Types
import { Props } from './types'

const MyAccount = (props: Props) => <div>MyAccount</div>

export default MyAccount
